module.exports = __webpack_public_path__ + "img/je.383ddb56.svg";